import { createSlice } from '@reduxjs/toolkit';
import {
  getSpecialtysList,
  addSpecialty,
  updateSpecialty,
  getSpecialtyById,
  deleteSpecialty,
  getSpecialtiesForFilter, // Assurez-vous que cet import est bien présent
} from './specialtysThunk';
import { toast } from 'react-toastify';

const initialState = {
  specialtys: [], // Conserve les données paginées pour la page des spécialités
  specialty: null, // Conserve les données d'une seule spécialité (pour l'édition)
  
  // --- NOUVEL AJOUT ---
  // Cet état stockera la liste COMPLÈTE des spécialités, non paginée, pour les filtres.
  specialtiesList: [],

  loading: false,
  error: null,
};

const specialtysSlice = createSlice({
  name: 'specialtys',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Cas existants pour la liste paginée (ne pas modifier)
      .addCase(getSpecialtysList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSpecialtysList.fulfilled, (state, action) => {
        state.specialtys = action.payload;
        state.loading = false;
      })
      .addCase(getSpecialtysList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Cas existants pour l'ajout
      .addCase(addSpecialty.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSpecialty.fulfilled, (state, action) => {
        toast.success('Specialty ajouté avec succès');
        state.specialty = action.payload;
        state.loading = false;
      })
      .addCase(addSpecialty.rejected, (state, action) => {
        toast.error("Erreur lors de l'ajout de la spécialité");
        state.loading = false;
        state.error = action.error.message;
      })

      // Cas existants pour la mise à jour
      .addCase(updateSpecialty.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSpecialty.fulfilled, (state, action) => {
        toast.success('Spécialité mis à jour avec succès');
        state.specialty = action.payload;
        state.loading = false;
      })
      .addCase(updateSpecialty.rejected, (state, action) => {
        toast.error("Erreur lors de la mise à jour de la spécialité");
        state.loading = false;
        state.error = action.error.message;
      })

      // Cas existants pour la recherche par ID
      .addCase(getSpecialtyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSpecialtyById.fulfilled, (state, action) => {
        state.specialty = action.payload;
        state.loading = false;
      })
      .addCase(getSpecialtyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Cas existants pour la suppression
      .addCase(deleteSpecialty.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSpecialty.fulfilled, (state) => {
        toast.success("La spécialité est supprimée avec succès !");
        state.loading = false;
      })
      .addCase(deleteSpecialty.rejected, (state, action) => {
        toast.error("Erreur lors de la suppression de la spécialité");
        state.loading = false;
        state.error = action.error.message;
      })

      // --- NOUVEL AJOUT : GESTION DE LA LISTE POUR LES FILTRES ---
      .addCase(getSpecialtiesForFilter.pending, (state) => {
        state.loading = true; // On peut réutiliser le même indicateur de chargement
        state.error = null;
      })
      .addCase(getSpecialtiesForFilter.fulfilled, (state, action) => {
        state.loading = false;
        // IMPORTANT : On met à jour la nouvelle propriété `specialtiesList`
        state.specialtiesList = action.payload;
      })
      .addCase(getSpecialtiesForFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // On peut aussi afficher un toast d'erreur si nécessaire
        toast.error("Erreur lors du chargement des spécialités pour les filtres.");
      });
  },
});

export default specialtysSlice.reducer;